import { Box, Button, Icon, Text, Stack } from '@chakra-ui/react'
import { Avatar, AvatarGroup } from './ui/avatar'
import { FiEdit } from "react-icons/fi";
import { ColorModeButton, useColorModeValue } from './ui/color-mode';
import { ThemeButton } from './ui/theme-button';
import { SettingsModal } from './settings';
import { useAccount } from './ui/account-context';
// HeroContext is not used in Sidebar itself, can remove if not needed elsewhere
// import { useContext } from 'react';
// import { HeroContext } from './block';
import { ChatAccordion } from './ui/chat-accordion'; // Assume this component exists and accepts new props
// Import the ChatSession type
import { ChatSession } from './chat-history';
import { useEffect } from 'react';
import { useAuth } from './ui/auth-context';

// Update SidebarProps interface
interface SidebarProps {
    setFontFamily: Function,
    fontFamily: string,
    onNewSession: () => void, // Handler from Block to start a new session
    // Add props related to chat history management
    chatSessions: () => ChatSession[]; // Array of chat session summaries
    onOldChatSelected: (sessionId: string) => void; // Handler when a history item is clicked
    onDeleteChat: (sessionId: string) => void; // Handler when delete is clicked for a session

    // Props for Chakra Box (position, maxW, etc.) - accept rest props
    [key: string]: any; // Allow any other props passed from parent (like maxW, position, etc.)
}


export const Sidebar = ({
    setFontFamily,
    fontFamily,
    onNewSession,
    chatSessions,
    onOldChatSelected,
    onDeleteChat,
    ...rest
}: SidebarProps) => {

    const { accountType, setAccountType, currentSessionId } = useAccount();
    const { user, loading } = useAuth();

    const handleNewChatClick = () => {
        // Block.tsx handler manages setting HeroVisible state
        onNewSession();
    }

    useEffect(() => {

    }, [])

    return (
        <Box p={2} {...rest} bgColor={useColorModeValue("#f9f9f9", "bg")} display={'flex'} flexDir={'column'} width={'100%'} height="100%">
            {/* New Chat Button - Fixed at top */}
            <Button
                onClick={handleNewChatClick} // Use the handler
                variant={'ghost'}
                p={1}
                gap={2}
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'}
                flexDir={'row'}
                height={'min-content'}
                width={'100%'}
                mb={4} // Add margin below button
            >
                <Box gap={2} display={'flex'} justifyContent={'flex-start'} alignItems={'center'} flexDir={'row'}>
                    <AvatarGroup >
                        <Avatar fontFamily={fontFamily} name={user.name} size={'md'} />
                    </AvatarGroup>
                    <Text fontFamily={fontFamily}>New Chat</Text>
                </Box>
                <Icon boxSize={5} mr={2}>
                    <FiEdit />
                </Icon>
            </Button>

            {/* Chat History List (ChatAccordion) - Flexible and scrollable area */}
            <Box flex="1" display="flex" flexDir="column" minH={0}>
                <ChatAccordion
                    sessions={chatSessions()}
                    onOldChatSelected={onOldChatSelected}
                    onDeleteChat={onDeleteChat}
                    fontFamily={fontFamily}
                    currentSessionId={currentSessionId}
                />
            </Box>

            {/* Bottom Sidebar (Settings, Theme, Color Mode) */}
            <Box borderTop="1px solid" borderTopColor={useColorModeValue("gray.200", "gray.700")} pt={4}>
                <Stack p={2} direction={'row'} justifyContent={'space-evenly'} alignItems={'center'} height={'min-content'} width={'100%'}>
                    <SettingsModal fontFamily={fontFamily} />
                    {accountType === 'admin' && (<ThemeButton setFontFamily={setFontFamily} fontFamily={fontFamily} />)}
                    <ColorModeButton />
                </Stack>
            </Box>
        </Box>
    )
}